import { Component, input, inject } from '@angular/core';

import { ApContentService, ApContentComponent } from '@ap/content';

import { AddressForm } from '../dutch-address.model';

import content from './read-only.content.json';

/**
 * @ngdoc component
 * @name ApReadonlyComponent
 * @description The dutch read only address that shows the content from an address object.
 * @param {DutchAddress} address       The address object.
 */
@Component({
    selector: 'ap-dutch-address-read-only',
    templateUrl: './read-only.component.html',
    imports: [ApContentComponent]
})
export class ApReadonlyComponent {
    private readonly contentService = inject(ApContentService);

    /**
     * Required - The address object
     */
    public readonly address = input.required<Record<keyof AddressForm, any>>();

    public constructor() {
        this.contentService.addContentItems(content);
    }
}
